import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { PublicProfileModels } from "./publicProfile.models";
import { CommonModels } from "@/data/common/common.models";

export namespace PublicProfileApi {
export const getProfilePublic = (userId: string, ) => { 
    return AppRestClient.get( 
        { resSchema: PublicProfileModels.PublicProfileResponseDtoSchema }, 
        `/public/profile/${userId}`,
        
    )
};

export const getJobSkillMatrix = (userId: string, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileJobSkillMatrixResponseDtoSchema }, 
        `/public/profile/${userId}/job-skill-matrix`,
        
    )
};

export const getBlsSkillIndustry = (userId: string, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileBlsSkillIndustryResponseDtoSchema }, 
        `/public/profile/${userId}/bls-skill-industry`,
        
    )
};

export const getEndorsements = (userId: string, ) => { 
    return AppRestClient.get( 
        { resSchema: PublicProfileModels.GetEndorsementsResponseSchema }, 
        `/public/profile/${userId}/endorsements`,
        
    )
};

export const getProfilePicture = (userId: string, ) => { 
    return AppRestClient.get( 
        { resSchema: PublicProfileModels.PublicProfilePictureDtoSchema }, 
        `/public/profile/${userId}/profile-picture`,
        
    )
};

}
